import styled from 'styled-components';

const DivInputAuthentication = styled.div`
  margin: 32px 0;
`;

export default DivInputAuthentication;
